module.exports = __webpack_public_path__ + "img/userPass 1.e28c1455.svg";